import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { observer, inject } from "mobx-react";
import Sticky from "react-stickynode";
import styled from "@emotion/styled";
import Card from "components/Card";
import VacationsTable, {
  VACATION_COLUMNS,
  VACATION_CARDS,
  VACATION_MIN_TABLE_WIDTH,
} from "components/Tables/Vacations";
import * as DataList from "components/DataList";
import SearchBars from "components/SearchBars";
import UserSidebar from "./user-sidebar";

const PageWrapGray = styled("div")`
  padding: 8px 12px;
  background-color: #f8fafb;
  min-height: calc(100vh - 75px);
`;

@inject("store", "viewStore", "userStore")
@observer
class UsersVacations extends Component {
  render() {
    const {
      viewStore,
      userStore,
      userStore: {
        vacations: { isLoading, isError },
      },
    } = this.props;

    let content;
    if (isLoading) {
      content = (
        <DataList.Loading
          columns={VACATION_COLUMNS}
          cards={VACATION_CARDS}
          minTableWidth={VACATION_MIN_TABLE_WIDTH}
          noun="vacations"
        />
      );
    } else if (isError) {
      content = (
        <DataList.LoadError
          noun="vacations"
          onRetry={() => userStore.loadUsersVacations()}
        />
      );
    } else {
      content = <VacationsTable />;
    }

    return (
      <div className="user-page-layout">
        <Helmet>
          <title>Vacations | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
            <UserSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.Vacations key={viewStore.listFiltersVersion} />
              </Sticky>

              <Card>{content}</Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    );
  }
}

export default UsersVacations;
